import { render, staticRenderFns } from "./JobOnWorker.vue?vue&type=template&id=196621b6"
import script from "./JobOnWorker.vue?vue&type=script&lang=js"
export * from "./JobOnWorker.vue?vue&type=script&lang=js"
import style0 from "./JobOnWorker.vue?vue&type=style&index=0&id=196621b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports